// @flow @jsx h

/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */

import { Component, h } from 'preact'

import styles from './index.css'

type Option = {
  value: string,
  label: string
}

type Props = {
  id: string,
  label: string,
  value: string,
  options: Option[],
  disabled: boolean,

  onBlur?: () => void,
  onChange?: () => void
}

class Select extends Component<Props> {
  render () {
    const { id, label, value, options, onBlur, onChange, disabled } = this.props

    return (
      <div class={styles.select}>
        <label for={id}>{label}</label>
        <select
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          disabled={disabled}
          id={id}
        >
          {options.map((option, idx) => {
            return (
              <option
                key={String(idx)}
                value={option.value}
                dangerouslySetInnerHTML={{ __html: option.label }}
              />
            )
          })}
        </select>
        <svg viewBox='0 0 30 30'>
          <use xlinkHref='#nrk-chevron-down' />
        </svg>
      </div>
    )
  }
}

export default Select



// WEBPACK FOOTER //
// ./src/v1/components/Select/index.js